import {
  convertCubiCasaImportToDesignerState,
} from '../../../lib/convertCubiCasaImportToDesignerState';
import {
  normalizeImportedFloorPlanGeometry,
} from '../../../lib/normalizeImportedFloorPlanGeometry';

export function importCubiCasaResponseToDesignerState(response, options = {}) {
  const converted = convertCubiCasaImportToDesignerState(response, options);
  const normalized = normalizeImportedFloorPlanGeometry(converted, options.normalizationOptions || {});

  return {
    ...normalized,
    canvasWidth: converted.canvasWidth,
    canvasHeight: converted.canvasHeight,
    rawOpenings: converted.rawOpenings,
  };
}

export {
  convertCubiCasaImportToDesignerState,
} from '../../../lib/convertCubiCasaImportToDesignerState';
export {
  normalizeImportedFloorPlanGeometry,
} from '../../../lib/normalizeImportedFloorPlanGeometry';
